import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth(); // 👈 CORRECTO

  const isLoggedIn = !!user;

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: 'rgba(10,10,10,0.55) !important',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(255,110,0,0.25)',

        '&.MuiAppBar-root': {
          backgroundImage: 'none',
        },

        '&::before': {
          display: 'none',
        },
      }}
    >
      <Toolbar sx={{ px: { xs: 2, md: 6 } }}>

        {/* LOGO */}
        <Typography
          component={Link}
          to="/home"
          sx={{
            flexGrow: 1,
            fontWeight: 'bold',
            fontSize: '1.3rem',
            textDecoration: 'none',
            color: '#fff',
            letterSpacing: '1px',
            textShadow: '0 0 10px rgba(255,110,0,0.7)',
            transition: '0.3s',

            '&:hover': {
              textShadow: '0 0 20px rgba(255,110,0,1)',
            }
          }}
        >
          REBEL FOX
        </Typography>

        {/* LINKS */}
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>

          {[
            { label: 'Inicio', path: '/home' },
            { label: 'Quiénes Somos', path: '/about' },
            { label: 'Noticias', path: '/news' },
            { label: 'Tienda', path: '/shop' },
            { label: 'Teams', path: '/teams' },
            { label: 'Ranking', path: '/ranking' },
            { label: 'Fama', path: '/fama' }
          ].map((item, i) => (
            <Button
              key={i}
              component={Link}
              to={item.path}
              sx={{
                color: '#fff',
                position: 'relative',
                fontWeight: 500,
                letterSpacing: '0.5px',
                px: 2,
                overflow: 'hidden',
                transition: 'all 0.3s ease',

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 6,
                  left: 0,
                  width: '0%',
                  height: '2px',
                  background: 'linear-gradient(90deg, #ff6e00, #ffae00)',
                  transition: 'width 0.3s ease',
                },

                '&:hover::after': {
                  width: '100%',
                },

                '&:hover': {
                  color: '#ffae00',
                  textShadow: '0 0 10px rgba(255,110,0,0.8)',
                },

                '&:active': {
                  transform: 'scale(0.95)',
                }
              }}
            >
              {item.label}
            </Button>
          ))}

          {/* 🔥 AUTH SECTION */}
          {!isLoggedIn ? (
            <>
              <Button
                component={Link}
                to="/login"
                sx={{
                  color: '#fff',
                  border: '1px solid rgba(255,110,0,0.5)',
                  ml: 2,
                  '&:hover': {
                    color: '#ffae00',
                    borderColor: '#ffae00'
                  }
                }}
              >
                Login
              </Button>

              <Button
                component={Link}
                to="/register"
                sx={{
                  color: '#000',
                  background: 'linear-gradient(90deg, #ff6e00, #ffae00)',
                  fontWeight: 'bold',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #ffae00, #ff6e00)',
                  }
                }}
              >
                Register
              </Button>
            </>
          ) : (
            <>
              <Button
                component={Link}
                to="/my-account"
                sx={{
                  color: '#fff',
                  border: '1px solid rgba(255,110,0,0.5)',
                  ml: 2,
                  '&:hover': {
                    color: '#ffae00',
                    borderColor: '#ffae00'
                  }
                }}
              >
                Mi Perfil
              </Button>

              <Button
                component={Link}
                to="/my-orders"
                sx={{
                  color: '#fff',
                  border: '1px solid rgba(255,110,0,0.5)',
                  ml: 1,
                  '&:hover': {
                    color: '#ffae00',
                    borderColor: '#ffae00'
                  }
                }}
              >
                Mis Compras
              </Button>

              <Button
                onClick={() => {
                  logout();
                  window.location.href = "/home";
                }}
                sx={{
                  color: '#000',
                  background: 'linear-gradient(90deg, #ff3b3b, #ff6e00)',
                  fontWeight: 'bold',
                  ml: 1,
                  '&:hover': {
                    background: 'linear-gradient(90deg, #ff6e00, #ff3b3b)',
                  }
                }}
              >
                Logout
              </Button>
            </>
          )}

        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;